module.exports = __webpack_public_path__ + "static/media/fleetdriverIcon.b776743b.svg";